/* eslint-disable eqeqeq */
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
  Redirect,
} from "react-router-dom";
import { Layout } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import URL from "../../constants/API_URL";
import POS from "../../components/POS";
import POS2 from "../../components/POS2";

const { Content } = Layout;

class Dashboard extends React.Component {
  componentWillMount() {
    if (localStorage.getItem("accessToken")) {
      axios({
        method: "POST",
        url: URL + "auth/validateToken",
        data: {
          bearerToken:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (!res.data) {
            localStorage.clear();
            localStorage.setItem("lang", "AR");
            localStorage.removeItem("persist:root");

            this.props.history.push("/");
            window.location.reload();
          }
        })
        .catch((err) => {
          // localStorage.clear();
          // localStorage.setItem("lang", "AR")
          // localStorage.removeItem("persist:root")
          // this.props.history.push('/')
          // window.location.reload()
        });
    } else {
      localStorage.removeItem("persist:root");

      this.props.history.push("/");
    }
  }
  constructor(props) {
    super(props);

    this.state = {
      collapsed: false,
      shouldHide: false,
    };
    if (
      this.state.shouldHide !==
        JSON.parse(localStorage.getItem("shouldHide")) &&
      this.state.collapsed !== JSON.parse(localStorage.getItem("collapsed"))
    ) {
      this.setState({
        collapsed: localStorage.getItem("collapsed"),
        shouldHide: localStorage.getItem("shouldHide"),
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize());
  }
  resize = () => {
    this.setState({ hideNav: window.innerWidth <= 1024 });
  };
  async componentDidMount() {
    window.reacthistory = this.props.history;
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    //set loader true
    await this.props.getData;
    //set loader false
    if (
      this.state.shouldHide !==
        JSON.parse(localStorage.getItem("shouldHide")) &&
      this.state.collapsed !== JSON.parse(localStorage.getItem("collapsed"))
    ) {
      this.setState({
        collapsed: localStorage.getItem("collapsed"),
        shouldHide: localStorage.getItem("shouldHide"),
      });
    }
  }
  handleToggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      shouldHide: !this.state.shouldHide,
    });
  };
  render() {
    let clientId = this.props.client.clientId;

    if (!this.props.user.accessToken) {
      return (
        <Redirect
          to={{
            pathname: "/",
          }}
        />
      );
    } else if (JSON.parse(localStorage.getItem("userData")).isPosUser) {
      return (
        <Redirect
          to={{
            pathname: "/pos",
          }}
        />
      );
    }
    const { props } = this;
    return (
      <Router>
        <Layout>
          <Layout>
            <Content
              style={{
                margin: "24px 16px",
                paddingLeft: 24,
                paddingRight: 24,
                paddingTop: 24,
                background: "#ecf0f5",
                minHeight: "100vh",
                height: "100%",
                maxHeight: "100vh",
                overflowY: "scroll",
              }}
            >
              <Switch>
                <Route
                  exact
                  path="/dashboard/pos"
                  render={() => <POS {...this.props} />}
                />
                <Route
                  exact
                  path="/dashboard/pos2"
                  render={() => <POS2 {...this.props} />}
                />
              </Switch>
            </Content>
          </Layout>
        </Layout>
      </Router>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
    client: state.clientById,
  };
};

export default connect(mapStateToProps)(withRouter(Dashboard));
